import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@monorepo-channels/shared/util-environments'
import { Client } from '../../../control-panel.service'
import { UpdateClientDto } from '@monorepo-channels/channels/domain'

export interface Category {
	_id?: string
	brand?: string
	enabled?: boolean
	type?: string
	partnerId?: string
	name?: string
	benefits?: string[]
	ranges?: number[]
}
@Injectable({
	providedIn: 'root',
})
export class ConciergeEditProfileService {
	private baseUrl = `${environment.channelsAPIURL}/api/v1`
	private http = inject(HttpClient)

	constructor() {}

	getRange(range: number): Observable<Category> {
		return this.http.get<Category>(`${this.baseUrl}/categories/range/${range}`)
	}

	updateClient(clientId: string, updateClient: UpdateClientDto): Observable<Client> {
		return this.http.patch<Client>(`${this.baseUrl}/clients/${clientId}`, updateClient)
	}
}
